var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { SortDirection } from "@core/plugin/tc/component/table/types";
import Component from "vue-class-component";
import { asQueryString } from "@core/helper/url";
var SortsMixin = /** @class */ (function (_super) {
    __extends(SortsMixin, _super);
    function SortsMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SortsMixin.prototype, "sortQueryName", {
        get: function () {
            return "".concat(this.prefix, "sort");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortsMixin.prototype, "shouldApplyDefaultSort", {
        get: function () {
            return !(this.sortQueryName in this.$route.query);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortsMixin.prototype, "sorts", {
        get: function () {
            var sorts = asQueryString(this.$route.query[this.sortQueryName]);
            if (sorts == null || sorts.length == 0) {
                return [];
            }
            return sorts.split(',').filter(function (o) { return o.length > 0; });
        },
        enumerable: false,
        configurable: true
    });
    SortsMixin.prototype.setSorts = function (value, method) {
        var _a;
        if (method === void 0) { method = 'push'; }
        var data = {
            query: __assign(__assign({}, this.$route.query), (_a = {}, _a[this.sortQueryName] = value.join(','), _a))
        };
        switch (method) {
            case 'push':
                return this.$router.push(data);
            case 'replace':
                return this.$router.replace(data);
            default:
                throw new Error("Unsupported setSorts method: \"".concat(method, "\""));
        }
    };
    Object.defineProperty(SortsMixin.prototype, "isMultiSort", {
        get: function () {
            return this.sorts.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SortsMixin.prototype, "sortedFieldNames", {
        get: function () {
            return this.sorts.map(function (o) { return o.startsWith('-') ? o.substring(1) : o; });
        },
        enumerable: false,
        configurable: true
    });
    SortsMixin.prototype.parseSortPart = function (part) {
        if (part.startsWith('-')) {
            return [SortDirection.Desc, part.substring(1)];
        }
        else {
            return [SortDirection.Asc, part];
        }
    };
    SortsMixin.prototype.getSortIndex = function (field) {
        var sorts = this.sortedFieldNames;
        for (var i = sorts.length - 1; i >= 0; i--) {
            var sort = sorts[i];
            if (sort == field.name) {
                return i;
            }
        }
        return -1;
    };
    SortsMixin.prototype.resolveSortDirection = function (field) {
        if (this.sorts.length == 0) {
            return SortDirection.None;
        }
        for (var _i = 0, _a = this.sorts; _i < _a.length; _i++) {
            var sort = _a[_i];
            if (sort == field.name) {
                return SortDirection.Asc;
            }
            else if (sort == "-".concat(field.name)) {
                return SortDirection.Desc;
            }
        }
        return SortDirection.None;
    };
    SortsMixin = __decorate([
        Component
    ], SortsMixin);
    return SortsMixin;
}(Vue));
export default SortsMixin;
